<template>
  <DetailsWithSwitchContainer :layer-id="layer.id">
    <template v-slot:switch-holder>
      <slot name="switch-holder"></slot>
    </template>

    <details
      @toggle="detailsClicked([$event, layer.id])"
      ref="layer.id"
      v-bind:open="isOpen(layer.id)"
      v-bind:class="{ invisible: !visibilityStatus }"
    >
      <summary>
        {{ layer.name }}
      </summary>

      <slot></slot>
    </details>
  </DetailsWithSwitchContainer>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DetailsWithSwitchContainer from '@/components/sidebar/parts/DetailsWithSwitchContainer.vue';

export default {
  props: {
    layer: {
      type: Object,
      required: true
    },
    openedLayers: {
      type: Array,
      required: true
    }
  },
  components: {
    DetailsWithSwitchContainer
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['layers']),
    visibilityStatus() {
      return !this.layer.isActive || this.layer.opacity == 0 ? false : true;
    }
  },
  methods: {
    isOpen() {
      if (this.openedLayers) {
        let index = this.openedLayers.indexOf(this.layer.id);

        if (index > -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    detailsClicked([event, layerId]) {
      let openStatus = event.target.getAttribute('open');

      let obj = {
        ...this.$route.params
      };
      let openSettings = JSON.parse(obj['openSettings']);

      var index = openSettings.indexOf(layerId);

      if (openStatus !== null) {
        if (index == -1) {
          openSettings.push(layerId);
        }
      } else {
        if (index > -1) {
          openSettings.splice(index, 1);
        }
      }

      obj['openSettings'] = JSON.stringify(openSettings);

      this.$router.replace({ name: 'base', params: obj }).catch((err) => {});
    }
  }
};
</script>

<style scoped>
.single-layer {
  position: relative;
}
.single-layer details summary {
  padding-right: 2.4rem;
}
.switch-holder {
  position: absolute;
  top: 0.6rem;
  right: 0.5rem;
  z-index: 1;
}
details.invisible {
  background-color: #f4f6f7;
}

details.invisible > summary {
  opacity: 0.5;
}
</style>
